import React from "react";
import { X, AlertOctagon } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Defect list — each entry has a class chip (Critical/Major/Minor), a
// description, and an optional row-number. Parent owns the array; this
// component is purely presentational with callbacks.
export function DefectList({ defects, onAdd, onUpdate, onRemove }) {
  const { t } = useLang();
  const anyCritical = defects.some((d) => d.class === "Critical");

  return (
    <section className="hag-surface p-4 mt-4" data-testid="defects-panel">
      <h3 className="text-sm font-bold uppercase tracking-widest text-[#4A627A] mb-3">{t("defects")}</h3>
      {defects.map((d, i) => (
        <div key={i} className="hag-surface p-3 mb-2">
          <div className="flex gap-2 flex-wrap">
            {["Critical", "Major", "Minor"].map((c) => (
              <button
                key={c}
                data-testid={`defect-class-${i}-${c}`}
                onClick={() => onUpdate(i, { class: c })}
                className={`tap-target px-3 rounded-md text-xs font-bold border ${
                  d.class === c
                    ? (c === "Critical" ? "grade-C" : c === "Major" ? "grade-B" : "grade-A")
                    : "bg-white border-[#1B3A5C]/15"
                }`}
              >
                {t(`class_${c.toLowerCase()}`)}
              </button>
            ))}
            <button data-testid={`defect-remove-${i}`} onClick={() => onRemove(i)} className="ml-auto text-red-600 text-xs">
              <X size={14} />
            </button>
          </div>
          <input
            data-testid={`defect-desc-${i}`}
            placeholder={t("description")}
            value={d.description}
            onChange={(e) => onUpdate(i, { description: e.target.value })}
            className="mt-2 w-full h-10 px-2 border border-[#1B3A5C]/15 rounded-md text-sm"
          />
          <input
            placeholder={t("row_number")}
            value={d.row_number}
            onChange={(e) => onUpdate(i, { row_number: e.target.value })}
            className="mt-2 w-full h-10 px-2 border border-[#1B3A5C]/15 rounded-md text-sm"
          />
        </div>
      ))}
      <button
        data-testid="add-defect-btn"
        onClick={onAdd}
        className="tap-target w-full border border-dashed border-[#1B3A5C]/25 rounded-md py-2 text-sm text-[#4A627A]"
      >
        + {t("add_defect")}
      </button>
      {anyCritical && (
        <div data-testid="critical-warning" className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-md p-2 flex items-center gap-2">
          <AlertOctagon size={14} /> {t("critical_defect_warning")}
        </div>
      )}
    </section>
  );
}
